import { AlertCircle, RefreshCw } from "lucide-react";

/**
 * Inline, discreet error notice for data loading failures.
 * Use when a non-critical API call fails — keeps the rest of the page usable.
 */
export default function DataErrorNotice({ onRetry, compact = false, message }) {
  const text = message || "Impossible de charger les données pour le moment, veuillez réessayer dans quelques instants.";
  return (
    <div className={`flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 ${compact ? "p-3" : "p-4"}`} data-testid="data-error-notice">
      <AlertCircle className={`text-amber-600 flex-shrink-0 ${compact ? "w-4 h-4 mt-0.5" : "w-5 h-5 mt-0.5"}`} />
      <div className="flex-1 min-w-0">
        <p className={`text-amber-900 ${compact ? "text-xs" : "text-sm"} leading-relaxed`}>{text}</p>
        {onRetry && (
          <button onClick={onRetry} className="mt-2 inline-flex items-center gap-1.5 text-xs font-medium text-amber-900 hover:text-amber-700 transition" data-testid="data-error-retry">
            <RefreshCw className="w-3 h-3" /> Réessayer
          </button>
        )}
      </div>
    </div>
  );
}
